import reduceReducers from 'reduce-reducers';

import preferredSiteReducer from './preferred-site-reducer';
import storePersistReducer from './store-persist-reducer';

export default reduceReducers(preferredSiteReducer, storePersistReducer);
